import { AxiosHeaderValue } from 'axios'

// eslint-disable-next-line default-param-last
export const downloadUrl = (
  url: string,
  headers: Record<string, AxiosHeaderValue | undefined> = {},
  fileName?: string,
) => {
  if (!window || !document) return
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName || document.title)
  const mimeType = headers['content-type'] ? headers['content-type'].toString().split(';')[0] : ''
  link.setAttribute('type', mimeType)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

// eslint-disable-next-line default-param-last
export const downloadBlob = (
  data: Blob,
  headers: Record<string, AxiosHeaderValue | undefined> = {},
  fileName?: string,
) => {
  if (!window || !document) return
  const url = window.URL.createObjectURL(data)
  downloadUrl(url, headers, fileName)
}
